<template>
	<div class="login">
		<h1>登录</h1>

		<section class="login_nei ">
			<form action="">
				<div class="login_input flex zhong ">
					<img src="../../image/login_a.png" />
					<input type="text" placeholder="请输入手机号" v-model.trim="model.Phone" />
				</div>
				<div class="login_input flex zhong ">
					<img src="../../image/login_b.png" />
					<input type="password" placeholder="密码由6-20位字符组成" v-model.trim="model.Password" />
				</div>
				<div class="login_box flex zhong">
					<input type="checkbox" v-model="rememberLoginState" />
					<p>记住登录状态</p>
				</div>
				<el-button type="primary" class="btn" @click="login">登录</el-button>
				<hgroup class="flex center">
					<span @click="passWord">忘记密码</span>
					<span @click="regsit">立即注册</span>
				</hgroup>
			</form>
		</section>
	</div>
</template>
<script>
import Cookies from 'js-cookie';
import { getToken } from '@/utils/getToken';

export default {
	name: 'login',
	data() {
		return {
			rememberLoginState: false,
			model: {
				Phone: '',
				Password: '',
				Type: 0,
				Id: 0
			},
			Evaluation: '',
			loginInfoModel: null,
			vId: 0
		};
	},
	created() {
		if (this.$route.query) {
			this.$route.query.type && (this.model.Type = Number(this.$route.query.type));
			this.$route.query.id && (this.model.Id = Number(this.$route.query.id));
			this.$route.query.vId && (this.vId = Number(this.$route.query.vId));
			
		}
		this.getSavedLoginInfo();
	},
	mounted() {
		var Evaluation = Cookies.get('Evaluation_key');
		if (Evaluation) {
			this.Evaluation = Evaluation;
			console.log('缓存', this.Evaluation);
		}
		if(this.$route.query&&this.$route.query.isTeacher)
		{
			sessionStorage.setItem('IsTeacherLogin',2);
		}
	},
	methods: {
		goEvaluation(type) {
			var that = this;
			// 登录后判断是否有次数
			that.$api.HtppRequest('Evaluation', 'GET', {}, function(res) {
				console.log('次数', res);
				if (res.code === 0) {
					var data = res.data;
					var nubr = 0;
					// 高考选科测评
					if (type === 'NewEvaluation') {
						nubr = data.IsNewEvaluation ? 1 : data.NewEvaluationNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/gaokao',
								query: {
									key: 'NewEvaluation',
									id: 1
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 根据科目选专业
					if (type === 'Major') {
						nubr = data.IsMajor ? 1 : data.MajorNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/major',
								query: {
									key: 'Major'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 根据专业选科目
					if (type === 'Subject') {
						nubr = data.IsSubject ? 1 : data.SubjectNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/subject',
								query: {
									key: 'Subject'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 升学途径
					if (type === 'Guide') {
						nubr = data.IsGuide ? 1 : data.GuideNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/guide',
								query: {
									key: 'Guide'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 升学途径分析测评
					if (type === 'Entrance') {
						nubr = data.IsEntrance ? 1 : data.EntranceNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/way',
								query: {
									key: 'Entrance',
									id: 2
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 测评
					if (type === 'Style') {
						nubr = data.IsStyle ? 1 : data.StyleNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'Style',
									id: 3
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'LearningTime') {
						nubr = data.IsLearningTime ? 1 : data.LearningTimeNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'LearningTime',
									id: 4
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'Psychological') {
						nubr = data.IsPsychological ? 1 : data.PsychologicalNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'Psychological',
									id: 5
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'EmotionManage') {
						nubr = data.IsEmotionManage ? 1 : data.EmotionManageNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'EmotionManage',
									id: 6
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'Comprehensive') {
						nubr = data.IsComprehensive ? 1 : data.ComprehensiveNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'Comprehensive',
									id: 7
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'Habit') {
						nubr = data.IsHabit ? 1 : data.HabitNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'Habit',
									id: 8
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'Motivation') {
						nubr = data.IsMotivation ? 1 : data.MotivationNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'Motivation',
									id: 9
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'StudySarason') {
						nubr = data.IsStudySarason ? 1 : data.StudySarasonNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'StudySarason',
									id: 10
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'Relationship') {
						nubr = data.IsRelationship ? 1 : data.RelationshipNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'Relationship',
									id: 11
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'Orientation') {
						nubr = data.IsOrientation ? 1 : data.OrientationNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'Orientation',
									id: 13
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'ShiEn') {
						nubr = data.IsShiEn ? 1 : data.ShiEnNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'ShiEn',
									id: 14
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'Temperament') {
						nubr = data.IsTemperament ? 1 : data.TemperamentNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'Temperament',
									id: 15
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'Shubo') {
						nubr = data.IsShubo ? 1 : data.ShuboNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'Shubo',
									id: 16
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'Usability') {
						nubr = data.IsUsability ? 1 : data.UsabilityNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'Usability',
									id: 17
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'Confidence') {
						nubr = data.IsConfidence ? 1 : data.ConfidenceNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'Confidence',
									id: 18
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'EQ') {
						nubr = data.IsEQ ? 1 : data.EQNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'EQ',
									id: 19
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'DISC') {
						nubr = data.IsDISC ? 1 : data.DISCNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'DISC',
									id: 20
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'ProfessionalPDP') {
						nubr = data.IsProfessionalPDP ? 1 : data.ProfessionalPDPNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'ProfessionalPDP',
									id: 21
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					if (type === 'ParentPDP') {
						nubr = data.IsParentPDP ? 1 : data.ParentPDPNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/style',
								query: {
									key: 'ParentPDP',
									id: 12
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 学生档案
					if (type === 'ArchivesPDP') {
						nubr = data.IsArchivesPDP ? 1 : data.ArchivesPDPNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/fileindex',
								query: {
									key: 'ArchivesPDP'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 智能填报测评
					if (type === 'UniversityScore') {
						nubr = data.IsUniversityScore ? 1 : data.UniversityScoreNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/lastIndex',
								query: {
									key: 'UniversityScore'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 专业分数线
					if (type === 'MajorScore') {
						nubr = data.IsMajorScore ? 1 : data.MajorScoreNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/majorScore',
								query: {
									key: 'MajorScore'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 省控分数线
					if (type === 'Provincial') {
						nubr = data.IsProvincial ? 1 : data.ProvincialNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/skScore',
								query: {
									key: 'Provincial'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 一分一段表
					if (type === 'Paragraph') {
						nubr = data.IsParagraph ? 1 : data.ParagraphNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/scoreTable',
								query: {
									key: 'Paragraph'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 高校查询
					if (type === 'University') {
						nubr = data.IsUniversity ? 1 : data.UniversityNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/lastSchool',
								query: {
									key: 'University'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 大学排名
					if (type === 'UniversityRank') {
						nubr = data.IsUniversityRank ? 1 : data.UniversityRankNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/lastRanking',
								query: {
									key: 'UniversityRank'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 专业查询
					if (type === 'ProfessionalInquiry') {
						nubr = data.IsProfessionalInquiry ? 1 : data.ProfessionalInquiryNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/lastMajor',
								query: {
									key: 'ProfessionalInquiry'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 职业查询
					if (type === 'OccupationInquiry') {
						nubr = data.IsOccupationInquiry ? 1 : data.OccupationInquiryNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/occupation',
								query: {
									key: 'OccupationInquiry'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 招生章程
					if (type === 'Admission') {
						nubr = data.IsAdmission ? 1 : data.AdmissionNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/constitution',
								query: {
									key: 'Admission'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 智能选院校
					if (type === 'Colleges') {
						nubr = data.IsColleges ? 1 : data.CollegesNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/znYuan',
								query: {
									key: 'Colleges'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 智能选专业
					if (type === 'MajorSelect') {
						nubr = data.IsMajorSelect ? 1 : data.MajorSelectNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/znZhuan',
								query: {
									key: 'MajorSelect'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 录取风险评估
					if (type === 'AdmissionRisk') {
						nubr = data.IsAdmissionRisk ? 1 : data.AdmissionRiskNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/assessment',
								query: {
									key: 'AdmissionRisk'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 同分数考生去向
					if (type === 'Whereabout') {
						nubr = data.IsWhereabout ? 1 : data.WhereaboutNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/lastGo',
								query: {
									key: 'Whereabout'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
					// 一键自能填报
					if (type === 'Voluntary') {
						nubr = data.IsVoluntary ? 1 : data.VoluntaryNum > 0 ? 1 : 0;
						if (nubr > 0) {
							that.$router.push({
								path: '/xzTianBaoIndex',
								query: {
									key: 'Voluntary'
								}
							});
						} else {
							that.$router.push('/system');
						}
					}
				}
			});
		},
		// 获取保存的登录信息
		getSavedLoginInfo() {
			this.loginInfoModel = this.$util.getloginInfo();
			if (this.loginInfoModel) {
				this.model.Phone = this.loginInfoModel.Phone;
				this.model.Password = this.loginInfoModel.Password;
			}
		},
		// 忘记密码
		passWord() {
			this.$router.push('/passWord');
		},
		// 注册
		regsit() {
			this.$router.push('/regsit');
		},
		// 登录
		login() {
			if (this.loginInfoModel && this.model.Phone === this.loginInfoModel.Phone && this.model.Password === this.loginInfoModel.Password) {
				this.model.Password = this.$util.decodePassword(this.model.Password);
			}
			this.$api
				.login(this.model)
				.then(res => {
					console.log('登录', res);
					if (res.code === 0) {
						if (this.rememberLoginState) {
							this.$util.saveloginInfo(this.model);
						}
						return Promise.resolve({
							username: res.data,
							password: '123456',
							grant_type: 'password'
						});
					} else if (res.code === 2) {
						this.$util.showError(res.msg || '登录失败');
						if (res.data) {
							setTimeout(() => {
								window.open(res.data);
							}, 1000);
						}
					} else {
						this.$util.showError(res.msg || '登录失败');
					}
					return Promise.reject(res.msg);
				})
				.then(res => {
					return getToken(res);
				})
				.then(() => {
					this.$store.dispatch('user/setLocalGuid');
					if (this.model.Type === 1 && this.model.Id > 0 && this.vId > 0) {
						this.$router.push({
							path: '/xzTianBao',
							query: {
								key: 'Voluntary',
								vId: this.vId
							}
						});
					} else {
						if (this.Evaluation) {
							this.goEvaluation(this.Evaluation);
						} else {
							this.$router.push('/home');
						}
					}
				});
		}
	},
	// 创建前设置
	beforeCreate() {
		document.querySelector('body').setAttribute('style', 'overflow: hidden;');
	},
	// 销毁前清除
	beforeDestroy() {
		Cookies.remove('Evaluation_key');
		document.querySelector('body').removeAttribute('style', 'overflow: hidden;');
	}
};
</script>
<style lang="scss" scoped>
.login_nei hgroup span:first-child::after {
	content: '';
	width: 2px;
	height: 14px;
	background-color: #bcbcbc;
	position: absolute;
	right: 0;
	top: 50%;
	margin-top: -7px;
	z-index: 1;
}

.login_nei hgroup span:first-child {
	padding-right: 20px;
}

.login_nei hgroup span {
	font-size: 14px;
	color: #999;
	position: relative;
	padding-left: 20px;
	cursor: pointer;
}

.login_nei hgroup span:hover {
	opacity: 0.7;
}

.login_nei hgroup {
	overflow: hidden;
	margin-top: 20px;
}

.btn {
	display: block;
	width: 100%;
	background-color: #333;
	border-color: #333;
	cursor: pointer;
}

.login_box p {
	font-size: 14px;
	margin-left: 0.5em;
}

.login_box {
	margin-bottom: 30px;
}

/*login_box*/

.login_input input::-webkit-input-placeholder {
	color: #999;
}

.login_input input:-moz-placeholder {
	color: #999;
}

.login_input input:-ms-input-placeholder {
	color: #999;
}

.login_input input {
	overflow: hidden;
	width: calc(100% - 30px);
	padding-left: 10px;
	font-size: 14px;
	color: #333;
	display: block;
	height: 100%;
}

.login_input img {
	display: block;
	width: 20px;
	height: 20px;
}

.login_input {
	margin-bottom: 20px;
	overflow: hidden;
	border-radius: 4px;
	height: 40px;
	border: solid 1px #06222c;
	padding: 0 10px;
	width: 100%;
	box-sizing: border-box;
}

.login_nei {
	overflow: hidden;
	width: 340px;
	margin: 60px auto 0 auto;
}

/*login_nei*/

.login h1::after {
	content: '';
	width: 160px;
	height: 6px;
	background-color: #333;
	position: absolute;
	left: 50%;
	margin-left: -80px;
	bottom: 0;
	z-index: 1;
}

.login h1 {
	padding: 10px 0 30px 0;
	overflow: hidden;
	border-bottom: solid 2px #333;
	font-size: 18px;
	color: #333;
	text-align: center;
	position: relative;
}

.login {
	overflow: hidden;
	width: 1200px;
	margin: 40px auto;
	background-color: #fff;
	padding: 20px;
	min-height: 50vh;
}
</style>
